export const countrycodes = [
  { value: "FI", name: "FI" },
  { name: "SE", value: "SE" },
  { name: "NO", value: "NO" },
  { name: "DE", value: "DE" },
  { name: "DK", value: "DK" },
  { name: "EE", value: "EE" },
  { name: "RU", value: "RU" }
];
